import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
export function Pricing() {
  const [frequency, setFrequency] = useState('monthly');
  return <section id="pricing" className="py-16 bg-gray-50" data-id="element-276">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-277">
        <div className="text-center mb-16" data-id="element-278">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-279">
            Transparent Pricing
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-280">
            Choose the perfect plan for your lifestyle and budget
          </p>
          <div className="mt-8 flex justify-center" data-id="element-281">
            <div className="p-1 bg-gray-200 rounded-lg inline-flex" data-id="element-282">
              <button className={`px-4 py-2 rounded-md text-sm font-medium ${frequency === 'monthly' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setFrequency('monthly')} data-id="element-283">
                Monthly
              </button>
              <button className={`px-4 py-2 rounded-md text-sm font-medium ${frequency === 'quarterly' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setFrequency('quarterly')} data-id="element-284">
                Quarterly
              </button>
              <button className={`px-4 py-2 rounded-md text-sm font-medium ${frequency === 'yearly' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setFrequency('yearly')} data-id="element-285">
                Yearly
              </button>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-286">
          {/* Basic Bloom */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-287">
            <div className="p-6" data-id="element-288">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-289">
                Basic Bloom
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-290">
                Perfect for beginners and small spaces
              </p>
              <div className="mt-4 mb-8" data-id="element-291">
                <p className="text-4xl font-bold text-gray-900" data-id="element-292">
                  {frequency === 'monthly' && 'KES 2,000'}
                  {frequency === 'quarterly' && 'KES 5,700'}
                  {frequency === 'yearly' && 'KES 20,000'}
                  <span className="text-sm font-normal text-gray-500" data-id="element-293">
                    /
                    {frequency === 'monthly' ? 'month' : frequency === 'quarterly' ? 'quarter' : 'year'}
                  </span>
                </p>
                {frequency !== 'monthly' && <p className="text-sm text-pink-700 mt-1" data-id="element-294">
                    {frequency === 'quarterly' ? 'Save 5%' : 'Save 15%'}
                  </p>}
              </div>
              <ul className="space-y-3 mb-8" data-id="element-295">
                <li className="flex items-start" data-id="element-296">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-297" />
                  <span className="text-gray-600" data-id="element-298">Monthly flower delivery</span>
                </li>
                <li className="flex items-start" data-id="element-299">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-300" />
                  <span className="text-gray-600" data-id="element-301">Seasonal selections</span>
                </li>
                <li className="flex items-start" data-id="element-302">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-303" />
                  <span className="text-gray-600" data-id="element-304">Basic care instructions</span>
                </li>
                <li className="flex items-start" data-id="element-305">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-306" />
                  <span className="text-gray-600" data-id="element-307">Email notifications</span>
                </li>
              </ul>
              <button className="w-full px-4 py-2 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-308">
                Get Started
              </button>
            </div>
          </div>
          {/* Standard Bloom */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow border-2 border-pink-600 relative" data-id="element-309">
            <div className="absolute top-0 inset-x-0 bg-pink-600 text-white text-center py-1 text-sm font-medium" data-id="element-310">
              Most Popular
            </div>
            <div className="p-6 pt-10" data-id="element-311">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-312">
                Standard Bloom
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-313">
                Our recommended option for most homes
              </p>
              <div className="mt-4 mb-8" data-id="element-314">
                <p className="text-4xl font-bold text-gray-900" data-id="element-315">
                  {frequency === 'monthly' && 'KES 4,500'}
                  {frequency === 'quarterly' && 'KES 12,150'}
                  {frequency === 'yearly' && 'KES 45,900'}
                  <span className="text-sm font-normal text-gray-500" data-id="element-316">
                    /
                    {frequency === 'monthly' ? 'month' : frequency === 'quarterly' ? 'quarter' : 'year'}
                  </span>
                </p>
                {frequency !== 'monthly' && <p className="text-sm text-pink-700 mt-1" data-id="element-317">
                    {frequency === 'quarterly' ? 'Save 10%' : 'Save 15%'}
                  </p>}
              </div>
              <ul className="space-y-3 mb-8" data-id="element-318">
                <li className="flex items-start" data-id="element-319">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-320" />
                  <span className="text-gray-600" data-id="element-321">
                    Bi-weekly flower delivery
                  </span>
                </li>
                <li className="flex items-start" data-id="element-322">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-323" />
                  <span className="text-gray-600" data-id="element-324">
                    Premium seasonal arrangements
                  </span>
                </li>
                <li className="flex items-start" data-id="element-325">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-326" />
                  <span className="text-gray-600" data-id="element-327">Detailed care guides</span>
                </li>
                <li className="flex items-start" data-id="element-328">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-329" />
                  <span className="text-gray-600" data-id="element-330">SMS notifications</span>
                </li>
                <li className="flex items-start" data-id="element-331">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-332" />
                  <span className="text-gray-600" data-id="element-333">
                    Free basic vase with first delivery
                  </span>
                </li>
              </ul>
              <button className="w-full px-4 py-2 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-334">
                Get Started
              </button>
            </div>
          </div>
          {/* Premium Bloom */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-335">
            <div className="p-6" data-id="element-336">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-337">
                Premium Bloom
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-338">
                Luxury arrangements for discerning customers
              </p>
              <div className="mt-4 mb-8" data-id="element-339">
                <p className="text-4xl font-bold text-gray-900" data-id="element-340">
                  {frequency === 'monthly' && 'KES 8,000'}
                  {frequency === 'quarterly' && 'KES 21,600'}
                  {frequency === 'yearly' && 'KES 81,600'}
                  <span className="text-sm font-normal text-gray-500" data-id="element-341">
                    /
                    {frequency === 'monthly' ? 'month' : frequency === 'quarterly' ? 'quarter' : 'year'}
                  </span>
                </p>
                {frequency !== 'monthly' && <p className="text-sm text-pink-700 mt-1" data-id="element-342">
                    {frequency === 'quarterly' ? 'Save 10%' : 'Save 15%'}
                  </p>}
              </div>
              <ul className="space-y-3 mb-8" data-id="element-343">
                <li className="flex items-start" data-id="element-344">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-345" />
                  <span className="text-gray-600" data-id="element-346">Weekly flower delivery</span>
                </li>
                <li className="flex items-start" data-id="element-347">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-348" />
                  <span className="text-gray-600" data-id="element-349">
                    Luxury designer arrangements
                  </span>
                </li>
                <li className="flex items-start" data-id="element-350">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-351" />
                  <span className="text-gray-600" data-id="element-352">
                    Premium care kit included
                  </span>
                </li>
                <li className="flex items-start" data-id="element-353">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-354" />
                  <span className="text-gray-600" data-id="element-355">
                    Priority delivery window
                  </span>
                </li>
                <li className="flex items-start" data-id="element-356">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-357" />
                  <span className="text-gray-600" data-id="element-358">
                    WhatsApp concierge service
                  </span>
                </li>
                <li className="flex items-start" data-id="element-359">
                  <CheckIcon className="h-5 w-5 text-pink-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-360" />
                  <span className="text-gray-600" data-id="element-361">Premium vase collection</span>
                </li>
              </ul>
              <button className="w-full px-4 py-2 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-362">
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}